import * as com from "../../Common"

export function calcMonthsFromPurchaseDate(purchaseDate) {
    let today = new Date()
    let purDate = new Date(purchaseDate)
    let monthFromPurchase = (today.getFullYear() - purDate.getFullYear()) * 12 + 
    (today.getMonth() - purDate.getMonth());        
    return monthFromPurchase
}

export function calculateLTAIVPercentage(asisvalue, initialLoanAmount) {
    return (
        100 * com.safeParseInt(initialLoanAmount)
        / 
        com.safeParseInt(asisvalue)
    ).toFixed(2)
}

export function calculateLTCPercentage(cost, totalLoanAmount) {
    return (
        100 * com.safeParseInt(totalLoanAmount) 
        / 
        com.safeParseInt(cost)
    ).toFixed(2)
}
  
export function calculateLTARVPercentage(arv, totalLoanAmount) {
    return (
        100 * com.safeParseInt(totalLoanAmount) 
        / 
        com.safeParseInt(arv)
    ).toFixed(2)
}
  
export function calculateTotalCost(asisvalue, rehabLoanAmount, interestReservesAmount) {
    return com.safeParseInt(asisvalue) +
     com.safeParseInt(rehabLoanAmount) + 
     com.safeParseInt(interestReservesAmount)
}

export function calcDefaultRate(borrowerExperience) {
    if (borrowerExperience >= 0 && borrowerExperience <3) {
      return 8.75
    } else if (borrowerExperience >= 3 && borrowerExperience <10) {
      return 9
    } else if (borrowerExperience >= 10) {
      return 10
    }
}

export function calculateInterestReservesAmount(interestReserves, totalLoanAmount, loanTermMonths, borrowerExperience) {
    return Math.round(
        com.safeParseInt(interestReserves)
        * 
        (0.7 * com.safeParseInt(totalLoanAmount) * calcDefaultRate(borrowerExperience)/100)
        / 
        com.safeParseInt(loanTermMonths)
    )
}

export function CalcHardMoneyLoanRate(props)  {
    // to get max loan amount:
    // if it's a purchase loan (+rehab)，the max loan amount is the lesser of 85% LTV or 70% LTARV. 
    // if it's a rate-term refi loan, the max loan amount is the lesser of 70% LTV or 70% LTARV. 
    // If it's a cash-out refi loan, the max is the lesser of 65% LTV or 65% LTARV.
    
      let result = {
        unqualified: false,
        unqualifiedReason: "", 
        floorRate: 0,
        point: 0,
        monthlyPayment: 0,
        closingCost: 0,
        maxLoanAmount: 0,
        initialLoanAmount: 0,
        rehabLoanAmount: 0,
        cashoutAmount: 0,
        constructionLoanAmount: 0,
        showContruction: false,
        showCashout: false,
        bridgeOnly: false,
        totalLoanAmount: 0,
        ltaiv: 0,
        ltc: 0,
        ltarv: 0,
        interestReservesAmount: 0,
        capRatio: "",
        originationFee: 0,
        underwritingFee: 0,
        cashtoclose: 0
      }
      const {
        property,
        hardmoneyloan,
      } = props.application;
    
      let propertyType = property.propertytype
      let propertyCounty = property.county
      let propertyCity = property.city.trim()
      let rehabAdded = hardmoneyloan.rehabloan
      let scre = hardmoneyloan.estimatedfico
      let borrowerExperience = hardmoneyloan.timesofflippingaproperty + hardmoneyloan.timesofpurchasingarentalproperty
      let loanTermMonths = com.safeParseInt(hardmoneyloan.mortgagetermmonths)
      let loanamount = ""
      let maxLoanAmount = ""
      let loanAmountLimit = ""
      let totalLoanAmount = ""
      let ltv = 0
      let ltarv = 0
      let ltc
      let floorRate = 8.99
      let floorRateLTC = 0
      let floorRateLTARV = 0
      let point = 0.25
      let originationPoint = 1
      let maxLTV = 0
      let maxLTARV = 0
      let maxLTC = 0
      let minFICO = 0
      let minExp = 3
      let minTermMonths = 3
      let dayOneEquity = 0
      let cashoutAmount = com.safeParseInt(props.cashoutAmount)
      let cashoutPercentage = 0
      let floorLoanAmount = 75000
      let cashtoclose = 0
      let showCashOutFailure = false
      let showContruction = false
      let showCashout = false
      let bridgeOnly = false
      let isCredit = false
      let netCredit = false
    
      let salesPrice = com.safeParseInt(property.salesprice)
      let asIsValue = com.safeParseInt(property.appraisal || hardmoneyloan.refinancedetails.estimatedCurrentValue)
      let loantype = hardmoneyloan.loantype
      let purpose = property.purpose
      let initialAdvance = com.safeParseInt(hardmoneyloan.initialadvancerequested)
      let initialLoanAmount = com.safeParseInt(hardmoneyloan.initialloanamount)
      let rehabBudget = com.safeParseInt(hardmoneyloan.rehaborconstructiondetails.rehaborconstructionbudget)
      // let interestReserves = hardmoneyloan.interestreserves
      let interestReserves = com.safeParseInt(props.interestReserves)
      let landEntitlement = props.landEntitlement
      let rehabLoanAmount = com.safeParseInt(hardmoneyloan.rehaborconstructionloanamount)
      let projectAfterRepairValue = com.safeParseInt(hardmoneyloan.projectedafterrepairvalue)
      let estimatedCurrentValue = com.safeParseInt(hardmoneyloan.refinancedetails.estimatedCurrentValue)
      let constructionBudget = com.safeParseInt(hardmoneyloan.rehaborconstructiondetails.rehaborconstructionbudget)
      let constructionLoanAmount = com.safeParseInt(hardmoneyloan.rehaborconstructionloanamount)
      let refinanceLoanAmount = com.safeParseInt(hardmoneyloan.refinanceloanamount)
      let existingLoanAmount = com.safeParseInt(hardmoneyloan.refinancedetails.existingLoanAmount)
      let noHeavyRehab = false
      let noGUC = false
      let interestReservesAmount = 0
      let capRatio = ""
      let costToDate = com.safeParseInt(hardmoneyloan.rehaborconstructiondetails.rehaborconstructioncostspenttodate)
      let monthsFromPurchase = com.safeParseInt(props.monthFromPurchase)
      let outofTerm = monthsFromPurchase > 6
      let assignmentFee = com.safeParseInt(hardmoneyloan.assignmentfeeamount)
      let lesserFee = assignmentFee < (salesPrice * 0.1) ? assignmentFee : salesPrice * 0.1
      let lesserPrice = salesPrice + lesserFee < asIsValue ? salesPrice + lesserFee : asIsValue
    
        //find min of purPrice * maxltv, cost * maxltc, arv * maxltarv
      const calcMaxLoanAmount = (asisvalue, cost, arv ,maxltv, maxltc, maxltarv, initialLoanAmount, totalLoanAmount, purpose) => {
        let maxLoanAmount = 0
        let maxLoanByLTAIV = 0
        let maxLoanByLTC = 0
        let maxLoanByLTARV = 0 
        maxLoanByLTC = cost * maxltc/100
        maxLoanByLTARV = arv * maxltarv/100
        maxLoanByLTAIV = asisvalue * maxltv/100 + (totalLoanAmount - initialLoanAmount)
       
      
        console.log("asisvalueMax: " + asisvalue+ "*" + maxltv + "+" + (totalLoanAmount - initialLoanAmount) + "="+maxLoanByLTAIV)
        console.log("costMax: " + cost+ "*" + maxltc + "="+maxLoanByLTC)
        console.log("arvMax: " + arv+ "*" + maxltarv + "="+maxLoanByLTARV)
        console.log("maxLoanAmount: " + Math.min(maxLoanByLTAIV, maxLoanByLTC, maxLoanByLTARV))
    
        maxLoanAmount = Math.min(maxLoanByLTAIV, maxLoanByLTC, maxLoanByLTARV)
        return maxLoanAmount
      }

      if (loantype === 'rehab'){
        purpose = "purchaserehab"
      } else if (loantype === 'groundup') {
        purpose = "construction"
      } else if (loantype === 'bridge') {
        if (purpose === "purchase") {
          purpose = "purchase"
        } else if (purpose === "refinance") {
          purpose = "refinance"
        } else if (purpose === "cashoutrefinance") {
          purpose = "cashoutrefinance"
        }
      }
    
      if (propertyType === "multistory") {
         loanAmountLimit = 5000000
      } else {
        if (borrowerExperience >= 10) {
          loanAmountLimit = 5000000
        } else {
          loanAmountLimit = 3000000
        }
      }
      if (salesPrice==="") {
        ltv = 0
      } else {
        switch (purpose) {
          case "purchaserehab":
            console.log("purchaserehab")
            bridgeOnly = false
            showContruction = false
            showCashout = false
            point = 0.25
            if (rehabBudget/asIsValue < 0.3) {
              if (borrowerExperience < 3) {
                maxLTV = 75
                maxLTC = 80
                maxLTARV = 70
              }
              if (borrowerExperience >= 3 && borrowerExperience <= 9) {
                maxLTV = 85
                maxLTC = 85
                maxLTARV = 75
              }
              if (borrowerExperience >= 10) {
                maxLTV = 85
                maxLTC = 90
                maxLTARV = 75
              }
            } else {
              if (borrowerExperience < 3) {
                maxLTV = 80
                maxLTC = 70
                maxLTARV = 85
                noHeavyRehab = true
              }
              if (borrowerExperience >= 3 && borrowerExperience <= 9) {
                maxLTV = 85
                maxLTC = 85
                maxLTARV = 70
              }
              if (borrowerExperience >= 10) {
                maxLTV = 85
                maxLTC = 90
                maxLTARV = 75
              }
            }

            if (existingLoanAmount == 0) {
              totalLoanAmount = initialLoanAmount + rehabLoanAmount
              ltv = calculateLTAIVPercentage(lesserPrice, initialLoanAmount)
              ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
              ltc = calculateLTCPercentage( asIsValue + rehabBudget, totalLoanAmount)
              if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
                maxLTC = 80
                maxLTARV = 65
              }
              maxLoanAmount = calcMaxLoanAmount(lesserPrice, asIsValue + rehabBudget, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              if (maxLoanAmount > loanAmountLimit) {
                console.log("check1")
                maxLoanAmount = loanAmountLimit
              }
              if(totalLoanAmount > maxLoanAmount) {
                console.log("check2")
                totalLoanAmount = maxLoanAmount
                console.log("check3", totalLoanAmount)
                console.log("check4", initialLoanAmount)
                console.log("check5", rehabLoanAmount)
                initialLoanAmount = totalLoanAmount - rehabLoanAmount
                console.log("check4", initialLoanAmount)
                ltv = calculateLTAIVPercentage(lesserPrice, initialLoanAmount)
                ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
                ltc = calculateLTCPercentage(asIsValue + rehabBudget, totalLoanAmount)
              }
              cashtoclose = salesPrice + lesserFee + rehabBudget - totalLoanAmount
            } else {
              totalLoanAmount = initialLoanAmount + rehabLoanAmount
              ltv = calculateLTAIVPercentage(asIsValue, initialLoanAmount)
              ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
              ltc = calculateLTCPercentage(salesPrice + lesserFee + rehabBudget + costToDate, totalLoanAmount)
              if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
                maxLTC = 80
                maxLTARV = 65
              }
              maxLoanAmount = calcMaxLoanAmount(asIsValue, salesPrice + lesserFee + rehabBudget + costToDate, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              if (outofTerm) {
                ltc = calculateLTCPercentage(asIsValue + rehabBudget, totalLoanAmount)
                maxLoanAmount = calcMaxLoanAmount(asIsValue, asIsValue + rehabBudget, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              }
              if (maxLoanAmount > loanAmountLimit) {
                maxLoanAmount = loanAmountLimit
              }
              if(totalLoanAmount > maxLoanAmount) {
                totalLoanAmount = maxLoanAmount
                initialLoanAmount = totalLoanAmount - rehabLoanAmount
                ltv = calculateLTAIVPercentage(asIsValue, initialLoanAmount)
                ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
                ltc = calculateLTCPercentage(salesPrice + rehabBudget + lesserFee+ costToDate, totalLoanAmount)
                if (outofTerm) {
                  ltc = calculateLTCPercentage(asIsValue + rehabBudget, totalLoanAmount)
                }
              }
              cashtoclose = existingLoanAmount + rehabBudget - totalLoanAmount
            }
          break;
          case "purchase":
            console.log("bridge purchase")
            bridgeOnly = true
            showContruction = false
            showCashout = false
            point = 0.25
            if (borrowerExperience < 3) {
              maxLTV = 70
              maxLTC = 70
              maxLTARV = 500
            }
            if (borrowerExperience >= 3 && borrowerExperience <= 9) {
              maxLTV = 75
              maxLTC = 75
              maxLTARV = 500
            }
            if (borrowerExperience >= 10) {
              maxLTV = 80
              maxLTC = 80
              maxLTARV = 500
            }
            // lesserPrice = salesPrice < asIsValue ? salesPrice : asIsValue
            console.log("initialLoanAmount", initialLoanAmount)
            totalLoanAmount = initialLoanAmount
            console.log("totalLoanAmount", totalLoanAmount)
            console.log("lesserPrice", lesserPrice)
            if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
              maxLTC = 80
              maxLTARV = 65
            }
            if (propertyType === "land") {
              maxLTV = 60
            }
            ltv = calculateLTAIVPercentage(lesserPrice, totalLoanAmount)
            ltarv = calculateLTARVPercentage(lesserPrice, totalLoanAmount)
            ltc = calculateLTCPercentage(lesserPrice, totalLoanAmount)
            maxLoanAmount = calcMaxLoanAmount(lesserPrice, lesserPrice, lesserPrice, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
            if (maxLoanAmount > loanAmountLimit) {
              maxLoanAmount = loanAmountLimit
            }
            if(totalLoanAmount > maxLoanAmount) {
              totalLoanAmount = maxLoanAmount
              initialLoanAmount = totalLoanAmount
              ltv = calculateLTAIVPercentage(lesserPrice, totalLoanAmount)
              ltarv = calculateLTARVPercentage(lesserPrice, totalLoanAmount)
              ltc = calculateLTCPercentage(lesserPrice, totalLoanAmount)
            }
            cashtoclose = salesPrice + lesserFee - totalLoanAmount
            break;
          case "refinance":
            console.log("bridge refinance")
            bridgeOnly = true
            showContruction = false
            showCashout = false
            point = 0.25
            if (borrowerExperience < 3) {
              maxLTV = 70
              maxLTC = 70
              maxLTARV = 500
            }
            if (borrowerExperience >= 3 && borrowerExperience <= 9) {
              maxLTV = 75
              maxLTC = 75
              maxLTARV = 500
            }
            if (borrowerExperience >= 10) {
              maxLTV = 80
              maxLTC = 80
              maxLTARV = 500
            }
            totalLoanAmount = initialLoanAmount
            if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
              maxLTC = 80
              maxLTARV = 65
            }
            if (propertyType === "land") {
              maxLTV = 60
            }
            ltv = calculateLTAIVPercentage(asIsValue, totalLoanAmount)
            ltarv = calculateLTARVPercentage(asIsValue, totalLoanAmount)
            ltc = calculateLTCPercentage(asIsValue, totalLoanAmount)
            maxLoanAmount = calcMaxLoanAmount(asIsValue, asIsValue, asIsValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
            if (maxLoanAmount > loanAmountLimit) {
              maxLoanAmount = loanAmountLimit
            }
            if(totalLoanAmount > maxLoanAmount) {
              totalLoanAmount = maxLoanAmount
              initialLoanAmount = totalLoanAmount
              ltv = calculateLTAIVPercentage(asIsValue, totalLoanAmount)
              ltarv = calculateLTARVPercentage(asIsValue, totalLoanAmount)
              ltc = calculateLTCPercentage(asIsValue, totalLoanAmount)
            }
            cashtoclose = existingLoanAmount - totalLoanAmount
            break;
          case "cashoutrefinance":
            console.log("bridge cashout refinance")
            bridgeOnly = true
            showContruction = false
            showCashout = true
            point = 0.25
            if (borrowerExperience < 3) {
              maxLTV = 70
              maxLTC = 70
              maxLTARV = 500
            }
            if (borrowerExperience >= 3 && borrowerExperience <= 9) {
              maxLTV = 75
              maxLTC = 75
              maxLTARV = 500
            }
            if (borrowerExperience >= 10) {
              maxLTV = 80
              maxLTC = 80
              maxLTARV = 500
            }
            if (cashoutAmount > 500000) {
              cashoutAmount = 500000
            }
            totalLoanAmount = cashoutAmount + existingLoanAmount
            initialLoanAmount = totalLoanAmount
            if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
              maxLTC = 80
              maxLTARV = 65
            }
            if (propertyType === "land") {
              maxLTV = 60
            }
            ltv = calculateLTAIVPercentage(asIsValue, totalLoanAmount)
            ltarv = calculateLTARVPercentage(asIsValue, totalLoanAmount)
            ltc = calculateLTCPercentage(asIsValue, totalLoanAmount)
            if (totalLoanAmount < existingLoanAmount) {
              showCashOutFailure = true
            } else {
              showCashOutFailure = false
            }
            maxLoanAmount = calcMaxLoanAmount(asIsValue, asIsValue, asIsValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
            if (maxLoanAmount > loanAmountLimit) {
              maxLoanAmount = loanAmountLimit
            }
            if(totalLoanAmount > maxLoanAmount) {
              totalLoanAmount = maxLoanAmount
              initialLoanAmount = totalLoanAmount
              if (totalLoanAmount < existingLoanAmount) {
                showCashOutFailure = true
              } else {
                showCashOutFailure = false
                ltv = calculateLTAIVPercentage(asIsValue, totalLoanAmount)
                ltarv = calculateLTARVPercentage(asIsValue, totalLoanAmount)
                ltc = calculateLTCPercentage(asIsValue, totalLoanAmount)
                cashoutAmount = totalLoanAmount - existingLoanAmount
              }
            }
            cashtoclose = totalLoanAmount - existingLoanAmount
            break;
          case "construction":
            console.log("bridge construction")
            point = 0.25
            bridgeOnly = false
            showContruction = true
            showCashout = false
              if (borrowerExperience < 3) {
                maxLTV = 70
                maxLTC = 70
                maxLTARV = 500
                noGUC = true
              }
              if (borrowerExperience >= 3 && borrowerExperience <= 9) {
                maxLTV = 85
                maxLTC = 85
                maxLTARV = 70
              }
              if (borrowerExperience >= 10) {
                maxLTV = 85
                maxLTC = 85
                maxLTARV = 75
              }

            if (existingLoanAmount == 0) {
              totalLoanAmount = initialLoanAmount + constructionLoanAmount
              interestReservesAmount = calculateInterestReservesAmount(interestReserves, totalLoanAmount, loanTermMonths, borrowerExperience)
              totalLoanAmount = totalLoanAmount + interestReservesAmount
              if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
                maxLTC = 80
                maxLTARV = 65
              }
              ltv = calculateLTAIVPercentage(lesserPrice, initialLoanAmount)
              ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
              ltc = calculateLTCPercentage(asIsValue + constructionBudget + interestReservesAmount, totalLoanAmount)
              maxLoanAmount = calcMaxLoanAmount(lesserPrice, asIsValue + constructionBudget + interestReservesAmount, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              if (maxLoanAmount > loanAmountLimit) {
                maxLoanAmount = loanAmountLimit
              }
              if(totalLoanAmount > maxLoanAmount) {
                totalLoanAmount = maxLoanAmount
                interestReservesAmount = calculateInterestReservesAmount(interestReserves, totalLoanAmount, loanTermMonths, borrowerExperience)
                initialLoanAmount = totalLoanAmount - constructionLoanAmount - interestReservesAmount
                ltv = calculateLTAIVPercentage(lesserPrice, initialLoanAmount)
                ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
                ltc = calculateLTCPercentage(asIsValue + constructionBudget + interestReservesAmount, totalLoanAmount)
              }
              cashtoclose = salesPrice + lesserFee + constructionBudget + interestReservesAmount - totalLoanAmount
            } else {
              totalLoanAmount = initialLoanAmount + constructionLoanAmount
              interestReservesAmount = calculateInterestReservesAmount(interestReserves, totalLoanAmount, loanTermMonths, borrowerExperience)
              totalLoanAmount = totalLoanAmount + interestReservesAmount
              if (propertyType !== "multistory" && totalLoanAmount > 3000000 && borrowerExperience >= 10) {
                maxLTC = 80
                maxLTARV = 65
              }
              ltv = calculateLTAIVPercentage(asIsValue, initialLoanAmount)
              ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
              ltc = calculateLTCPercentage(salesPrice + lesserFee + costToDate + constructionBudget + interestReservesAmount, totalLoanAmount)
              maxLoanAmount = calcMaxLoanAmount(asIsValue, salesPrice + lesserFee + costToDate + constructionBudget + interestReservesAmount, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              if (outofTerm) {
                ltc = calculateLTCPercentage(asIsValue + constructionBudget + interestReservesAmount, totalLoanAmount)
                maxLoanAmount = calcMaxLoanAmount(asIsValue, asIsValue + constructionBudget + interestReservesAmount, projectAfterRepairValue, maxLTV, maxLTC, maxLTARV, initialLoanAmount, totalLoanAmount, purpose)
              }
              if (maxLoanAmount > loanAmountLimit) {
                maxLoanAmount = loanAmountLimit
              }
              if(totalLoanAmount > maxLoanAmount) {
                totalLoanAmount = maxLoanAmount
                interestReservesAmount = calculateInterestReservesAmount(interestReserves, totalLoanAmount, loanTermMonths, borrowerExperience)
                initialLoanAmount = totalLoanAmount - constructionLoanAmount - interestReservesAmount
                ltv = calculateLTAIVPercentage(asIsValue, initialLoanAmount)
                ltarv = calculateLTARVPercentage(projectAfterRepairValue, totalLoanAmount)
                ltc = calculateLTCPercentage(salesPrice + lesserFee + costToDate + constructionBudget + interestReservesAmount, totalLoanAmount)
                if (outofTerm) {
                  ltc = calculateLTCPercentage(asIsValue + constructionBudget + interestReservesAmount, totalLoanAmount)
                }
              }
              if (initialLoanAmount > existingLoanAmount) {
                cashtoclose = initialLoanAmount - existingLoanAmount
                isCredit = true
              } else {
                cashtoclose = existingLoanAmount + constructionBudget + interestReservesAmount - totalLoanAmount
                isCredit = false
              }
            }
          break;
        }
      }
    
    
      // check lending area 
      // if (!eligibleCities.includes(propertyCity) && !eligibleCounties.includes(propertyCounty)) {
      //   console.log("not in lending area")
      //   result.unqualified = true
      //   result.unqualifiedReason = "The subject property address is not in the lending area of this program."
      // }
      // check multifamily or mixeduse, rates for these are subject to pre-approval
      // if (propertyType === "multifamily" || propertyType === "mixeduse") {
      //   console.log("is multifamily or mixeduse, need pre-approval")
      //   result.unqualified = true
      //   result.unqualifiedReason = "Program's rate and cost is subject to pre-approval for multifamily or mixed used property, please procced to the applicaton and discuss it with your loan officer."
      // }
      originationPoint = 1
      point = point + originationPoint
    
      if (borrowerExperience < 3) {
        if (ltc <= 70) {
          floorRateLTC = 9.75
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0
            }
          } else if (ltc > 70 && ltc <= 75) {
            floorRateLTC = 10.25
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0
            }
          } else if (ltc > 75 && ltc <= 80) {
            floorRateLTC = 10.75
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0
            }
          } else if (ltc > 80 && ltc <= 85) {
            floorRateLTC = 500
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0
            }
            if (purpose === "construction") {
              floorRateLTC += 0
            }
          }
      }
    
      if (borrowerExperience >= 3 && borrowerExperience <= 9) {
          if (ltc <= 70) {
            floorRateLTC = 9
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.75
            }
          } else if (ltc > 70 && ltc <= 75) {
            floorRateLTC = 9.25
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.75
            }
          } else if (ltc > 75 && ltc <= 80) {
            floorRateLTC = 9.25
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.75
            }
          } else if (ltc > 80 && ltc <= 85) {
            floorRateLTC = 9.5
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0
            }
            if (purpose === "construction") {
              floorRateLTC += 0.75
            }
          }
    
        }
    
        if (borrowerExperience >= 10) {
          if (ltc <= 70) {
            floorRateLTC = 8.5
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.5
            }
          } else if (ltc > 70 && ltc <= 75) {
            floorRateLTC = 9
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.5
            }
          } else if (ltc > 75 && ltc <= 80) {
            floorRateLTC = 9
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0.25
            }
            if (purpose === "construction") {
              floorRateLTC += 0.5
            }
          } else if (ltc > 80 && ltc <= 85) {
            floorRateLTC = 9.25
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0
            }
            if (purpose === "construction") {
              floorRateLTC += 0.5
            }
          } else if (ltc > 85 && ltc <= 90) {
            floorRateLTC = 9.5
            if (scre > 740) {
              floorRateLTC -= 0.25
            }
            if (scre < 700) {
              floorRateLTC += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTC += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTC += 0
            }
            if (purpose === "construction") {
              floorRateLTC += 0.5
            }
          }
      }
    
      if (borrowerExperience < 3) {
        if (ltarv <= 60) {
          floorRateLTARV = 9.75
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0
            }
          } else if (ltarv > 60 && ltarv <= 65) {
            floorRateLTARV = 10.25
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0
            }
          } else if (ltarv > 65 && ltarv <= 70) {
            floorRateLTARV = 10.75
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0
            }
          } else if (ltarv > 70 && ltarv <= 75) {
            floorRateLTARV = 500
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0
            }
            if (purpose === "construction") {
              floorRateLTARV += 0
            }
          }
      }
    
      if (borrowerExperience >= 3 && borrowerExperience <= 9) {
          if (ltarv <= 60) {
            floorRateLTARV = 9
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.75
            }
          } else if (ltarv > 60 && ltarv <= 65) {
            floorRateLTARV = 9.25
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.75
            }
          } else if (ltarv > 65 && ltarv <= 70) {
            floorRateLTARV = 9.25
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.75
            }
          } else if (ltarv > 70 && ltarv <= 75) {
            floorRateLTARV = 9.5
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.75
            }
          }
        }
    
        if (borrowerExperience >= 10) {
          if (ltarv <= 60) {
            floorRateLTARV = 8.5
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.5
            }
          } else if (ltarv > 60 && ltarv <= 65) {
            floorRateLTARV = 9
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.5
            }
          } else if (ltarv > 65 && ltarv <= 70) {
            floorRateLTARV = 9
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0.25
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.5
            }
          } else if (ltarv > 70 && ltarv <= 75) {
            floorRateLTARV = 9.25
            if (scre > 740) {
              floorRateLTARV -= 0.25
            }
            if (scre < 700) {
              floorRateLTARV += 0.25
            }
            if (totalLoanAmount > 3000000) {
              floorRateLTARV += 0.25
            }
            if (purpose === "cashoutrefinance") {
              floorRateLTARV += 0
            }
            if (purpose === "construction") {
              floorRateLTARV += 0.5
            }
          }
      }
    
      if (floorRateLTC === 500 && floorRateLTARV < 500) {
        floorRate = floorRateLTARV
      } else if (floorRateLTC < 500 && floorRateLTARV === 500) {
        floorRate = floorRateLTC
      } else {
        floorRate = Math.max(floorRateLTC, floorRateLTARV)
      }

      if (loanTermMonths > 12) {
        let termAdjustment = 0.25* ((loanTermMonths - 12) / 6)
        floorRate = floorRate + termAdjustment
      }
    
      // if (ltv > maxLTV) {
      //   console.log("ltv exceed maxLTV: " + maxLTV)
      //   result.unqualified = true
      //   result.unqualifiedReason = "The maximum LTV is "+ maxLTV +", whereas the LTV you have provided is " + ltv.toFixed(0) + "%"
      // }
    
      // if (ltc > maxLTC) {
      //   console.log("ltc exceed maxLTC: " + maxLTC)
      //   result.unqualified = true
      //   result.unqualifiedReason = "The maximum LTC is "+ maxLTC +", whereas the LTC you have provided is " + ltc.toFixed(0) + "%"
      // }
    
      // if (ltarv > maxLTARV) {
      //   console.log("ltarv exceed maxLTARV: " + maxLTARV)
      //   result.unqualified = true
      //   result.unqualifiedReason = "The maximum LTARV is "+ maxLTARV +", whereas the LTARV you have provided is " + ltarv.toFixed(0) + "%"
      // }

      if (propertyType === "commercial" || propertyType === "mixeduse" || propertyType === "multistory") {
        console.log("commercial, mixeduse, or multistory")
        result.unqualified = true
        result.unqualifiedReason = "Pre-approval pricing for the current property type is subject to the loan officer's final review and decision. You may proceed with your application, and a loan officer will contact you shortly."
      }
    
      if (totalLoanAmount > loanAmountLimit) {
        console.log("loan amount exceed: " + loanAmountLimit)
        result.unqualified = true
        result.unqualifiedReason = "The maximum loan amount is $"+ loanAmountLimit/1000000 + "M, while your current is $"+ totalLoanAmount + "."
      }
    
      if (totalLoanAmount < floorLoanAmount) {
        console.log("loan amount below floor loan amount: " + floorLoanAmount)
        result.unqualified = true
        result.unqualifiedReason = "The minimum loan amount is $"+ "75,000" + ", while your current is $"+ totalLoanAmount + "."
      }
    
      if (floorRate >= 500) {
        console.log("No experience borrower is not eligible for this speicifc ltc and ltarv interval.")
        result.unqualified = true
        result.unqualifiedReason = "Your LTC and LTARV are not qualified for this program based on your experience level."
      }
    
      if (noGUC) {
        console.log("no experience borrower is not eligible for GUC")
        result.unqualified = true
        result.unqualifiedReason = "No experience borrower is not eligible for a GUC loan."
      }
      if (noHeavyRehab) {
        console.log("no experience borrower is not eligible for heavy rehab")
        result.unqualified = true
        result.unqualifiedReason = "No experience borrower is not eligible for a heavy rehab loan."
      }

      if (landEntitlement === "permitnotready") {
        console.log("permit is not ready")
        result.unqualified = true
        result.unqualifiedReason = "You must have a land permit ready to be eligible for this loan."
      }
    
      if (showCashOutFailure) {
        console.log("cash out failure")
        result.unqualified = true
        result.unqualifiedReason = "Your current applicable loan amount can't not supply a cash out."
      }
    
      if (property.salesprice === "" || property.salesprice == 0) {
        console.log("purchase price is empty or zero")
        result.unqualified = true
        result.unqualifiedReason = "Please enter a valid purchase price/as-is-value, can't be empty or zero"
      }
    
      // make sure projected after repair value is entered valid if rehab added
      if ((rehabAdded || purpose === "construction") && (hardmoneyloan.projectedafterrepairvalue === "" || hardmoneyloan.projectedafterrepairvalue === 0)) {
        console.log("projected after repair value is empty or zero")
        result.unqualified = true
        result.unqualifiedReason = "Please enter a valid projected after repair value, can't be empty or zero"
      }
    
      console.log("check type!!!!!!", propertyType)
    
      console.log("final total loan amount: " + totalLoanAmount)
      // calc final monthly payment and closing cost
      let mp = Math.round(0.01*(floorRate)*com.safeParseInt(totalLoanAmount)/com.safeParseInt(props.application.hardmoneyloan.mortgagetermmonths))
      let cc = Math.round(com.safeParseInt(totalLoanAmount) * point * 0.01) + cashtoclose 
      if (isCredit || purpose === "cashoutrefinance") {
        cc = Math.round(com.safeParseInt(totalLoanAmount) * point * 0.01) - cashtoclose
        netCredit = true
      }
      if ((purpose === "construction" || purpose === "purchaserehab") && cc < 0) {
        cc = 0
      }

      if (purpose === "purchaserehab" || purpose === "construction") {
        if (ltv === maxLTV.toFixed(2)) {
          capRatio = "LTAIV"
        } else if (ltc === maxLTC.toFixed(2)) {
          capRatio = "LTC"
        } else if (ltarv === maxLTARV.toFixed(2)) {
          capRatio = "LTARV"
        }
      } else {
        if (ltv === maxLTV.toFixed(2)) {
          capRatio = "LTAIV"
        }
      }
    
    
      result.floorRate = floorRate
      result.point = point
    
      result.monthlyPayment = mp
      result.closingCost = cc
      result.maxLoanAmount = maxLoanAmount
      result.initialLoanAmount = initialLoanAmount
      result.rehabLoanAmount = rehabLoanAmount
      result.cashoutAmount = cashoutAmount
      result.showContruction = showContruction
      result.showCashout = showCashout
      result.bridgeOnly = bridgeOnly
      result.constructionLoanAmount = constructionLoanAmount
      result.totalLoanAmount = totalLoanAmount
      result.ltaiv = ltv
      result.ltc = ltc
      result.ltarv = ltarv
      result.interestReservesAmount = interestReservesAmount
      result.capRatio = capRatio
      result.originationFee = originationPoint * 0.01 * totalLoanAmount
      result.underwritingFee = 0.25 * 0.01 * totalLoanAmount
      result.cashtoclose = netCredit ? -cashtoclose : cashtoclose
      return result
}